import React, { useState, useEffect, useCallback } from "react";
import { testimonials } from "../../data/mockData";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

const TestimonialsSection = () => {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const goTo = useCallback((index) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrent(index);
    setTimeout(() => setIsAnimating(false), 500);
  }, [isAnimating]);

  const next = useCallback(() => {
    goTo((current + 1) % testimonials.length);
  }, [current, goTo]);

  const prev = useCallback(() => {
    goTo((current - 1 + testimonials.length) % testimonials.length);
  }, [current, goTo]);

  useEffect(() => {
    const timer = setInterval(next, 7000);
    return () => clearInterval(timer);
  }, [next]);

  const t = testimonials[current];

  return (
    <section className="py-28 relative">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center max-w-xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-white/[0.03] border border-white/[0.07] rounded-full px-4 py-1.5 mb-6">
            <span className="text-[11px] text-[#7a7a7a] uppercase tracking-widest font-medium">Testimonials</span>
          </div>
          <h2 className="text-3xl md:text-[2.75rem] font-bold text-white tracking-[-0.02em] leading-tight">
            Loved by 10,000+ creative teams.
          </h2>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="relative rounded-2xl border border-white/[0.06] bg-[#0a0a0c] p-10 md:p-14">
            {/* Quote icon */}
            <div className="absolute top-8 right-8">
              <Quote size={36} className="text-white/[0.04]" />
            </div>

            <div key={current} className="space-y-8" style={{ animation: "fadeIn 0.5s ease-out" }}>
              <p className="text-white/85 text-lg md:text-xl leading-relaxed font-light">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover border border-white/[0.1]"
                />
                <div>
                  <p className="text-white font-medium text-sm">{t.name}</p>
                  <p className="text-[#555] text-[13px]">{t.title}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-between mt-6">
            <div className="flex items-center gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goTo(i)}
                  className={`rounded-full transition-all duration-400 ${
                    i === current
                      ? "w-8 h-1.5 bg-white/80"
                      : "w-1.5 h-1.5 bg-white/[0.12] hover:bg-white/[0.25]"
                  }`}
                />
              ))}
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={prev}
                className="w-9 h-9 rounded-full border border-white/[0.08] flex items-center justify-center text-white/30 hover:text-white/70 hover:border-white/[0.15] transition-all duration-300"
              >
                <ChevronLeft size={15} />
              </button>
              <button
                onClick={next}
                className="w-9 h-9 rounded-full border border-white/[0.08] flex items-center justify-center text-white/30 hover:text-white/70 hover:border-white/[0.15] transition-all duration-300"
              >
                <ChevronRight size={15} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
